import React from 'react'

import { selectMonth } from '../../../domain/helpers/SelectedMonth'

import {
  formatCpf,
  getCardBrandImageById,
  getCardBrandImageByPaymentTypeAndId,
  numberToCurrency
} from '../../../infra/utils'
import Selo from '../../assets/icone_menu_fidelidade.png'

import history from '../../../history'

import { ReactComponent as LocationIcon } from '../../assets/icons/icon_checkout_address.svg'
import { ReactComponent as IconPhone } from '../../assets/icons/icon_phone.svg'
import { ReactComponent as IconTyping } from '../../assets/icons/icon_typing.svg'

import {
  Container,
  OrderSummaryTitle,
  ItemsList,
  Item,
  ItemDetails,
  ItemName,
  ItemDescription,
  ItemPrice,
  ItemAmount,
  TotalsWrapper,
  TotalsItem,
  SubTotalLabel,
  SubTotalValue,
  DeliveryFeeLabel,
  DeliveryFeeValue,
  TotalLabel,
  TotalValue,
  DeliveryAddressWrapper,
  DeliveryAddressLabel,
  DeliveryAddress,
  DeliveryPaymentWrapper,
  DeliveryPaymentCard,
  ActionButton,
  CardImage,
  Help,
  HelpLabel,
  HelpButton,
  DeliveryEarnedPointsWrapper,
  DeliveryEarnedPointsLabel,
  DeliveryEarnedPoints
} from './styles'
import { HAS_CASHBACK, HAS_LOYALTY } from '../../../config'
import { CashbackPoints } from '../Delivery'

const SubtotalText = ({ subtotal }) => (<>
  <SubTotalLabel>Subtotal:</SubTotalLabel>
  <SubTotalValue>{numberToCurrency(subtotal)}</SubTotalValue>
</>)

const DiscountText = ({ discount }) => (<>
  {discount ? <><DeliveryFeeLabel>Desconto:</DeliveryFeeLabel>
    <DeliveryFeeValue>{numberToCurrency(discount)}</DeliveryFeeValue></> :
    null}
</>)

const DeliveryFeeText = ({ deliveryFee, modalityId }) => (<>
  <DeliveryFeeLabel>{modalityId === 4 ? 'Taxa de entrega' : 'Taxa de retirada'}:</DeliveryFeeLabel>
  <DeliveryFeeValue>{deliveryFee ? `${numberToCurrency(deliveryFee)}` : 'Grátis'}</DeliveryFeeValue>
</>)

const TotalText = ({ total }) => (<>
  <TotalLabel>TOTAL:</TotalLabel>
  <TotalValue>{numberToCurrency(total)}</TotalValue>
</>)

const SelectedCard = ({ brand, number, payOnDelivery }) => {
  return <>
    {brand && number && !payOnDelivery ? <>
      <CardImage src={brand} alt={`Bandeira do cartao: ${getCardBrandImageById(brand)}`} />

      <span>{number}</span>
    </> : <>
      <CardImage src={getCardBrandImageByPaymentTypeAndId(1, 0)} alt='Bandeira do cartão' />

      <span>Pagamento na entrega</span>
    </>
    }
  </>
}

const Points = ({ earnedPoints }) => {
  return <>
    {earnedPoints ? <>
      <img src={Selo} width="40px" alt="Sele de pontos" />

      <span>{earnedPoints} pontos</span>
    </> : null}
  </>
}

export function OrderSummary({
  products = {},
  buttonName,
  className,
  deliveryAddress,
  cardBrand,
  cardNumber,
  modalityId,
  storeAddress,
  handleTrackOrder,
  scheduling,
  phone,
  whatsapp,
  cpf,
  hasCpf,
  URLParameters,
  setOverlay,
  payOnDelivery,
  earnedPoints
}) {

  const openWhattsApp = (whatsapp) => {
    window.open(`https://api.whatsapp.com/send?phone=${whatsapp}`);
  }

  const hasCashback = JSON.parse(HAS_CASHBACK);
  const hasLoyalty = JSON.parse(HAS_LOYALTY);

  return (
    <Container className={className} scheduling={scheduling}>
      <OrderSummaryTitle>Resumo do Pedido</OrderSummaryTitle>
      {
        products && products.list && products.list.map((item, index) => {
          const {
            quantity,
            product,
            value,
            description,
            id
          } = item

          const key = `checkout-listitem-${index}-${id}`

          return <ItemsList key={key}>
            <Item>
              <ItemDetails>
                <ItemName>{product}</ItemName>
                <ItemDescription>{`${description}`}</ItemDescription>
                <ItemPrice>{numberToCurrency(value)}</ItemPrice>
              </ItemDetails>
              <ItemAmount>{quantity}</ItemAmount>
            </Item>
          </ItemsList>
        })
      }
      {products.summary && <TotalsWrapper>
        <TotalsItem>
          <SubtotalText subtotal={products.summary.subtotal} />
        </TotalsItem>
        <TotalsItem>
          <DiscountText discount={products.summary.discount} />
        </TotalsItem>
        <TotalsItem>
          <DeliveryFeeText deliveryFee={products.summary.deliveryFee} modalityId={modalityId} />
        </TotalsItem>
        <TotalsItem>
          <TotalText total={products.summary.total} />
        </TotalsItem>
      </TotalsWrapper>}
      {scheduling && <DeliveryAddressWrapper>
        <DeliveryAddressLabel>Data da Entrega</DeliveryAddressLabel>
        <DeliveryAddress className="schedule">
          {scheduling}
        </DeliveryAddress>
      </DeliveryAddressWrapper>}
      <DeliveryAddressWrapper>
        <DeliveryAddressLabel>{
          modalityId === 4 ?
            'Local de entrega' :
            'Local de retirada'}
        </DeliveryAddressLabel>
        <DeliveryAddress>
          <LocationIcon />
          {modalityId === 4 ? deliveryAddress : storeAddress}
        </DeliveryAddress>
      </DeliveryAddressWrapper>
      <DeliveryPaymentWrapper>
        <DeliveryAddressLabel>Forma de Pagamento</DeliveryAddressLabel>
        <DeliveryPaymentCard>
          <SelectedCard brand={cardBrand} number={cardNumber} />
        </DeliveryPaymentCard>
      </DeliveryPaymentWrapper>
      {(hasLoyalty && earnedPoints > 0) && (
        <DeliveryEarnedPointsWrapper>
          <DeliveryEarnedPointsLabel>Pontos Ganhos</DeliveryEarnedPointsLabel>
          <DeliveryEarnedPoints>
            <Points earnedPoints={earnedPoints} />
          </DeliveryEarnedPoints>
        </DeliveryEarnedPointsWrapper>
      )
      }
      {(hasCashback && earnedPoints > 0) && (
        <DeliveryEarnedPointsWrapper>
          <DeliveryEarnedPointsLabel>Cashback Ganho</DeliveryEarnedPointsLabel>
          <DeliveryEarnedPoints>
            <CashbackPoints earnedPoints={earnedPoints} />
          </DeliveryEarnedPoints>
        </DeliveryEarnedPointsWrapper>
      )
      }
      <DeliveryAddressWrapper>
        <DeliveryAddressLabel>CPF na nota</DeliveryAddressLabel>
        <DeliveryAddress>
          {hasCpf ? formatCpf(cpf) : '000.000.000-00'}
        </DeliveryAddress>
      </DeliveryAddressWrapper>
      {(phone || whatsapp) && <Help>
        <HelpLabel>Precisa de ajuda?</HelpLabel>
        {whatsapp && <HelpButton onClick={() => openWhattsApp(whatsapp)}>
          Fale conosco
          <IconTyping />
        </HelpButton>}
        {phone && <HelpButton href={`#${phone}`} onClick={() => {
          if (setOverlay) {
            setOverlay(true)
          }
        }}>
          Ligar para loja
          <IconPhone />
        </HelpButton>}
      </Help>}
      <ActionButton onClick={() => {
        if (handleTrackOrder) {
          handleTrackOrder()

          return
        }

        history.push(`/${URLParameters}`)
      }}>{buttonName}</ActionButton>
    </Container>
  )
}
